module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/index.svg?82153b325068ba9237ec2acbd395ce83";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/index.svg
// module id = 84
// module chunks = 0